import EditModeToggleComponent from '../../components/EditModeToggle/EditModeToggle';
import styles from './EditModeToggle.module.css';

function EditModeToggleBlock() {
  return (
    <div className={styles.wrapper}>
      <EditModeToggleComponent />
    </div>
  );
}

export default EditModeToggleBlock;
